import React from "react"
import ReactDOM from "react-dom/client"
import "normalize.css"
import "./styles/Global.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import firebase from "firebase/compat/app"

const root = ReactDOM.createRoot(document.getElementById("root"))

firebase.initializeApp({
	apiKey: "AIzaSyAc3l1-sfLlz0pLrBnqrMv5ajk8gGkJUbA",
	authDomain: "auth.googlefeud.com",
	projectId: "gfeud2022",
	storageBucket: "gfeud2022.appspot.com",
	messagingSenderId: "1021061313029",
	appId: "1:1021061313029:web:c64f8baf3b7dead67ae26c",
	measurementId: "G-XTQ5L45WJP",
})

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
